export default {
    openapp: "បើកកម្មវិធី",
    noStore: "ហាងមិនមានទេ។",
    rating: "ពិន្ទុ:",
    Categories: "ប្រភេទទំនិញ:",
    PreparationTime: "ពេលវេលារៀបចំអាហារ:",
    DeliveryFee: "ថ្លៃដឹកជញ្ជូន",
    FreeDelivery:"ឥតគិតថ្លៃដឹកជញ្ជូន",
    noScore: 'មិនមានការវាយតម្លៃ',
    discountTitle: 'បញ្ចុះតម្លៃ',
    fullReductionTitle: 'ទិញគ្រប់ចំនួនបញ្ចុះតម្លៃ',
    storeFirstTitle: 'បញ្ជាទិញលើកដំបូង',
    couponTitle: 'គូប៉ុង',
}